import { render, staticRenderFns } from "./CloseBtns.vue?vue&type=template&id=7ead7f1c&scoped=true&"
import script from "./CloseBtns.vue?vue&type=script&lang=js&"
export * from "./CloseBtns.vue?vue&type=script&lang=js&"
import style0 from "./CloseBtns.vue?vue&type=style&index=0&id=7ead7f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead7f1c",
  null
  
)

export default component.exports